import {getRunBrowser, isiOS} from '@/utils/runTimeEnv'
import { Toast } from 'vant'
import {RuntimeEnv} from '@/utils/helper/helper-enum'
// 分享参数配置
export interface objType {
  title: string
  desc: string
  link: string
  imgUrl: string
  type?: string
}

/**
 * 比较 app 版本，version 版本是否大于 minVersion
 * @param version
 * @param minVersion
 * @returns
 */
 export const isAHigherVersionThanB = (versionA: string, versionB: string) => {
  if (!versionB) {
    throw new Error('被比较的版本号不能为空！')
  }
  if (!versionA) {
    return false
  }
  const arrayA = versionA.split('.')
  const arrayB = versionB.split('.')
  if (!arrayA[0]) {
    return false
  }
  for (let i = 0; i < arrayA.length || i < arrayB.length; ++i) {
    // 如果不存在，默认 0
    let numberA = 0
    let numberB = 0
    if (i < arrayA.length) {
      numberA = parseInt(arrayA[i])
    }
    if (i < arrayB.length) {
      numberB = parseInt(arrayB[i])
    }
    if (numberA > numberB) {
      return true
    }
    if (numberA < numberB) {
      return false
    }
  }
  // 版本号相等，返回 false
  return false
}


// 获取app版本
export const getAppVersion = () => {
  let _getAppVer = null
  if (isiOS()) {
    window.webkit.messageHandlers.PCJSKit.postMessage({ functionName: 'appVer' });
  } else if (window.PCJSKit) {
    _getAppVer = window.PCJSKit.appVer()
  }
  window.appVer = (data: any) => {
    _getAppVer = data
  }
  return _getAppVer
}

export const shareConfig = (obj: Partial<objType>) => {
  const _default = {
    title: '太平洋汽车网',
    desc: '买车就选太平洋汽车网，好礼送不停',
    imgUrl: '',
    type: 'all',
    link: window.location.href.split('?')[0].replace('w1ssl', 'www1'),
  }
  const data = Object.assign({}, _default, obj)

  if (getRunBrowser() === RuntimeEnv.PCApp) {
    const shareStr = JSON.stringify({
      title: data.title,
      desc: data.desc,
      link: data.link,
      type: data.type ? data.type : null,
      imgUrl: data.imgUrl,
    })

    if (isiOS() && window?.webkit?.messageHandlers?.PCJSKit) {
      window.webkit.messageHandlers.PCJSKit.postMessage({
        functionName: 'updateShareInfo',
        data: shareStr,
      })
    } else if (window?.PCJSKit?.updateShareInfo) {
      // pcautobrowser://more/?uri=协议跳转中使用 window.PCJSKit.updateShareInfo(data)
      window.PCJSKit.updateShareInfo(shareStr)
    } else {
      Toast('请更新到最新版本app：分享')
    }
  } else if (getRunBrowser() === RuntimeEnv.WeChat) {
    // alert("触发微信浏览器分享")
    window.wxApi.init(() => {
      const shareData = {
        title: obj.title,
        desc: obj.desc,
        link: obj.link,
        imgUrl: obj.imgUrl,
        success: function () {
          // 用户确认分享后执行的回调函数
          console.log(1111111)
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          console.log(22222)
        }
      }
      if (window.wx) {
        window.wx.onMenuShareAppMessage(shareData) // 分享给朋友
        window.wx.onMenuShareTimeline(shareData) // 分享到朋友圈
        window.wx.onMenuShareQQ(shareData) // 分享到QQ
        window.wx.onMenuShareWeibo(shareData) // 分享到微博
      }
    })
  }
}
// app登录用户获取sessionId
export const getAppCommonSessionId = () => {
  let _getCommonSessionId = null
  if (isiOS()) {
    window.webkit.messageHandlers.PCJSKit.postMessage({ functionName: 'commonSessionId' });
  } else {
    _getCommonSessionId = window.PCJSKit.commonSessionId()
  }
  window.commonSessionId = (data: any) => {
    _getCommonSessionId = data
  }
  return _getCommonSessionId
}

// 通用跳转协议 'pcautobrowser://more/?uri='

// 是否json字符串
export const isJsonString = (str: any) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
  return false
}